// Add your custom JS here.
import './scrollspy-sidebar.js';

window.setCookie = (cname, cvalue, exdays) => {
	const d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

window.getCookie = (cname) => {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

jQuery('.dropdown-menu').on('click', function(event) {
    if (window.innerWidth < 992) {
        event.stopPropagation();
    }
});

jQuery('.dropdown-menu .dropdown').on('touchend', function(e) {
    
    if (window.innerWidth >= 992) {
        if (!jQuery(this).hasClass('submenu-active')) {
            e.preventDefault();
            jQuery('.submenu-active').removeClass('submenu-active');
            jQuery(this).addClass('submenu-active');
        }
    } else {
        jQuery('.submenu-active').removeClass('submenu-active');
    }
    
});

/**
 * Applies a class to the header on page scroll
 * Used by sticky-nav
 * 
 */
jQuery(window).scroll(function() {
    if (window.scrollY >= 100) {
        jQuery('#wrapper-navbar').addClass('header-scrolled');
    } else {
        jQuery('#wrapper-navbar').removeClass('header-scrolled');
    }
});

// /**
//  * Closes the offcanvas nav when an item is selected that doesn't change page location
//  * 
//  */
// var myOffcanvas = document.getElementById('navbarNavOffcanvas');
// var bsOffcanvas = new window.BootstrapOffcanvas(myOffcanvas);
// jQuery('.offcanvas-body a').on('click', function() {
//     if ( jQuery(this).hasClass('dropdown-toggle') || !jQuery(this).parent().hasClass('current-menu-item') ) return;
//     bsOffcanvas.hide();
// });